import { useLogout } from '@refinedev/core'
import { useTranslation } from 'react-i18next'
import { Button } from '~/components/ui/button'

/** The signed-in account has no tenant membership and is not staff. */
export function NoTenantPage() {
  const { t } = useTranslation()
  const { mutate: logout } = useLogout()
  return (
    <div className="flex min-h-[50vh] flex-col items-center justify-center gap-4 text-center">
      <h1 className="text-2xl font-bold">{t('auth.noTenant.title')}</h1>
      <p className="text-muted-foreground text-sm">
        {t('auth.noTenant.description')}
      </p>
      <Button
        onClick={() => {
          logout()
        }}
      >
        {t('auth.noTenant.signOut')}
      </Button>
    </div>
  )
}
